import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Whether the merchant has switched the Доставка sub-app to LEGACY mode — a
 * 1-to-1 reproduction of the previous merchant panel (UI *and* business logic),
 * kept available while the rewritten screens bed in.
 *
 * This is a durable UI preference, so it lives in Zustand and is persisted —
 * it is not server state and must not be mirrored into TanStack Query (see
 * CLAUDE.md §2). It is stored under its OWN key rather than added to
 * `ui-prefs` so that removing legacy mode later is deleting this slice, not
 * migrating a shared persisted blob.
 *
 * Default is `true`: for now every user stays in the old Доставка UI while the
 * rewritten screens are kept hidden.
 */
interface LegacyModeState {
  enabled: boolean;
  toggle: () => void;
  setEnabled: (enabled: boolean) => void;
}

export const useLegacyModeStore = create<LegacyModeState>()(
  persist(
    (set) => ({
      enabled: true,
      toggle: () => set({ enabled: true }),
      setEnabled: () => set({ enabled: true }),
    }),
    { name: 'legacy-mode' },
  ),
);

/**
 * Read-only subscription to the flag. The common case is a component that only
 * needs to know which UI to render — taking the whole store there would
 * re-render it whenever the setters' identity changed.
 */
export const useLegacyMode = () => true;
